import React, { RefObject } from 'react';

import { PopperProps } from '../../types';

export enum addMenuItemType {
  basic_blocks = 'Menu.sections.BasicBlocks',
  media = 'Menu.sections.Media',
  embeds = 'Menu.sections.Embeds',
  assessments = 'Menu.sections.Assessments',
  contents = 'Menu.sections.Contents',
  interactive_blocks = 'Menu.sections.InteractiveBlocks',
  advanced_blocks = 'Menu.sections.AdvancedBlocks',
}

export type blockType = {
  name: string;
  title: React.ReactNode | string;
  icon: any;
  addMenuIcon: any;
  addMenuItemType: addMenuItemType;
  description: React.ReactNode;
  attrs?: Object;
  searchWords: string[];
  isText?: boolean;
};

export type addMenuProps = {
  open: boolean;
  editorView: any;
  offset: number[];
  anchorEl: PopperProps['anchorEl'];
  placement: PopperProps['placement'];
  match?: string;
  blocks: blockType[];
  isMicroLearning?: boolean;
  isByteContent?: boolean;
};

export type getMenuPluginProps = {
  blocks: blockType[];
};

export type handleKeyDownTypes = (
  open: boolean,
  selectedMenuItemIndex: number,
  setSelectedMenuItemIndex: (newSelectedMenuitem: number) => void,
  availableBlocks: blockType[],
  onMenuItemClick: (block: blockType) => void,
  view: any,
  menuRef: React.RefObject<HTMLDivElement>,
) => void;

type menuItemClickMapCondition = (view: any, block: blockType) => boolean;
type menuItemClickMapCallback = (view: any, block: blockType, attrs?: Object) => void;

export type menuItemClickMapTypes = {
  condition: menuItemClickMapCondition;
  callback: menuItemClickMapCallback;
};

export interface AddMenuProps {
  open: boolean;
  onClick?: (block: blockType) => void;
  onClose: () => void;
  blocksMap: Map<addMenuItemType, blockType[]>;
  placement: PopperProps['placement'];
  anchorEl: PopperProps['anchorEl'];
  popperOptions: PopperProps['popperOptions'];
  selectedMenuItemIndex?: number;
  menuRef: RefObject<HTMLDivElement>;
  isMicroLearning?: boolean;
}
